import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { RichHeading } from '@/components/common/Heading';
import { HeadingLevel } from '@/components/common/MarkUp';
import { Section } from '@/components/layout/Section';
import { getRandomFromArray } from '@/lib/utils';
import { defaultDecorativeColours } from '@/sanity/schemas/objects/colourObjects/decorativeColours';

import { BarChart } from './BarChart';
import { DoughnutChart } from './DoughnutChart';

import type { SanityChartsGraphsType } from '@/types/sanity';

export interface ChartsProps extends SanityChartsGraphsType {}

export const Chart = ({ charts, heading }: ChartsProps) => {
  const updatedCharts = charts.map((chart) => {
    const dataNum = chart.data.length;
    const defaultColours = getRandomFromArray(
      defaultDecorativeColours,
      dataNum,
    );
    chart.data.map((d, index) =>
      typeof d.colour === 'object' ? null : (d.colour = defaultColours[index]),
    );

    return chart;
  });

  return (
    <Section backgroundColour="--background-subtle" verticalPadding>
      <HeadingLevel>
        <HeadingContainer>
          <RichHeading heading={heading} size="headline-lg" />
        </HeadingContainer>
        <ChartsContainer>
          {updatedCharts.map((chart) => {
            switch (chart.type) {
              case 'doughtnut':
                return <DoughnutChart key={chart._key} {...chart} />;
              case 'bar':
                return <BarChart key={chart._key} {...chart} />;
              default:
                return null;
            }
          })}
        </ChartsContainer>
      </HeadingLevel>
    </Section>
  );
};

const HeadingContainer = styled.div`
  text-align: center;
`;

const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 300px));
  justify-content: center;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: flex;
    justify-content: space-between;
  }

  justify-items: center;
  margin-top: var(--spacing-x-large);
  grid-gap: var(--spacing-200);

  ${screen.sm} {
    justify-content: center;
  }

  ${screen.md} {
    grid-gap: var(--spacing-500);
  }
`;
